// extracted by mini-css-extract-plugin
export var filterIncDec = "_er-0";
export var leftBorder = "_er-1";
export var rightBorder = "_er-2";
export var stringInput = "_er-3";